// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bk00","title":"styles_title__1zCFv"};